import React from 'react';
import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import { McpAgentType } from '@shared/constants/mcp';
import TipsMcp from './tips-mcp';
import Conf from '@/common/conf';
import TipsSuper from './tips-super';
import globalStore from '@/store/global';
import { SVGPureIcon } from '@/ui';

const SearchList = observer(({ inputRef }) => {
  const isSearch = agentPageStore.showSearchList;
  const isRecord = agentPageStore.showRecordList;
  if (isSearch && !agentPageStore.searched) return null;
  if (isRecord && !agentPageStore.recorded) return null;
  return (
    <div
      style={{
        maxHeight: 'calc(100vh - 280px)',
        boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)'
      }}
      className={[
        'z-99 w-full bg-white overflow-y-auto nw-scrollbar-thin pl-16px pr-24px py-8px rounded-16px mt-40px',
      ]}
      
    >
      {/* <div className="w-[calc(100%-24px)] h-1px mx-auto bg-black bg-opacity-10"></div> */}
      {isRecord ? (
        <>
          {!agentPageStore.recordList.length ? (
            <div className="h-40px pl-12px my-16px leading-40px text-black text-opacity-70">
              暂无使用记录
            </div>
          ) : (
            <div className="h-40px pl-12px mt-16px leading-40px text-black text-opacity-70">
              最近使用
            </div>
          )}
        </>
      ) : null}

      {isSearch ? (
        <>
          {/* {!agentPageStore.searchList.length ? (
            <div className="h-40px pl-12px my-16px leading-40px text-black text-opacity-70">
              暂无搜索结果
            </div>
          ) : (
            <div className="h-40px pl-12px mt-16px leading-40px text-black text-opacity-70">
              搜索结果
            </div>
          )} */}
          {
            !agentPageStore.searchList.length && 
              <div className="h-40px pl-12px my-16px leading-40px text-black text-opacity-70">
                暂无搜索结果
              </div>
          }
        </>
      ) : null}
      {(isSearch ? agentPageStore.searchList : agentPageStore.recordList).map(
        item => {
          return (
            <div
              onClick={evt => {
                agentPageStore.gotoAgentChat(item.id);
                agentPageStore.setInputVal('')
              }}
              key={item.id}
              className={[
                'h-72px w-full flex items-center last:mb-8px last:border-none',
                'hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px group relative',
                'border-b-1px border-black border-opacity-4 cursor-pointer',
              ]}
            >
              <img
                src={item.icon || Conf.agentIocn}
                className="size-40px rounded-full ml-8px mr-16px object-cover"
                alt=""
              />
              <div className="w-0 flex-grow pr-8px">
                <div className="w-full flex items-center truncate">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.title, //目前只高亮了title
                    }}
                    className="agent-search-title text-16px text-black font-bold leading-22px mb-2px truncate"
                  ></div>
                  {[McpAgentType.normal, McpAgentType.simple].includes(
                    item.agent_type * 1
                  ) ? (
                    <TipsMcp />
                  ) : null}
                  {globalStore.isLimitedAgent(item.id) ? (
                    <TipsSuper className="ml-6px" tip='vip' />
                  ) : null}
                </div>
                <div className="text-12px text-black text-opacity-50 leading-17px truncate">
                  创建者：{item.creator}
                </div>
              </div>
              {isRecord ? (
                <div
                  onClick={evt => {
                    agentPageStore.lockMomentCanBlur();
                    agentPageStore.delRecord(item.id, () => {
                      inputRef.current.focus();
                    });
                    evt.stopPropagation();
                  }}
                  className={[
                    'absolute right-20px top-1/2 transform -translate-y-1/2 size-24px',
                    'hidden group-hover:flex items-center justify-center',
                    'text-black text-opacity-50 hover:bg-[rgba(0,0,0,0.03)] hover:text-opacity-100',
                    'rounded-8px cursor-pointer',
                  ]}
                >
                  <SVGPureIcon name="icon_delete" className="size-16px" />
                </div>
              ) : null}
            </div>
          );
        }
      )}
    </div>
  );
});

export default SearchList;
